module.exports = __webpack_public_path__ + "static/media/crucero.96483ac2.jpg";